export default __webpack_public_path__ + "static/media/robin-room_whatsapp-avatar.8588f782.png";